import React from 'react';
import PropTypes from 'prop-types';
import { withProviderErrorBoundary } from '@edreamsodigeo/frontend-core';
import { AvailableCabinBagsProvider } from '../AvailableCabinBagsProvider';
import { SelectedCabinBagsProvider } from '../SelectedCabinBagsProvider';
import { PrimeInfoProvider } from '../PrimeInfoProvider';
import { SessionProvider } from '../SessionProvider';
import { VersionedRevampProvider } from '../RevampProvider';
import { SelectAncillariesProvider } from '../SelectAncillariesProvider';

export const CabinBagsProvider = ({ children }) => {
  return (
    <AvailableCabinBagsProvider>
      <SelectedCabinBagsProvider>
        <SelectAncillariesProvider>
          <PrimeInfoProvider>
            <VersionedRevampProvider>
              <SessionProvider>{children}</SessionProvider>
            </VersionedRevampProvider>
          </PrimeInfoProvider>
        </SelectAncillariesProvider>
      </SelectedCabinBagsProvider>
    </AvailableCabinBagsProvider>
  );
};

CabinBagsProvider.propTypes = {
  children: PropTypes.node,
};

export default withProviderErrorBoundary(CabinBagsProvider, {
  name: 'CabinBagsProvider',
});
